import React from 'react';
import { Icon } from 'antd';
import { phoneMask } from '../../../../../utils/phoneMask';
import styles from '../AddTenantModal.module.scss';
import cn from 'classnames';

const iconStyle = { marginRight: 5 };

const ConfirmContent = ({ address, phone, autoInfo = false }) => {
  return (
    <>
      <div className={styles.addressContainer}>
        <Icon type="environment" style={iconStyle} />
        {address || ''}
      </div>
      <div className={styles.phoneContainer}>
        <Icon type="phone" style={iconStyle} />
        {phone ? phoneMask(phone) : ''}
      </div>
      {autoInfo && (
        <div className={styles.warningContainer}>
          <span className={cn(styles.warning_red, styles.warning)}>
            !Внимание:
          </span>{' '}
          <span className={styles.warning}>
            У собственника есть пропуска, оформленные по этому адресу.
            Аннулировать пропуска и удалить привязку к адресу?
          </span>
        </div>
      )}
    </>
  );
};

export default ConfirmContent;
